/* ==========================================================================
   custom-script.js
   Centrale JS voor alle Boelou custom-liquid secties.
   Elk blok hieronder is verantwoordelijk voor 1 sectie en zoekt zelf al
   zijn instanties op via querySelectorAll, zodat het ook werkt als een
   sectie meerdere keren op dezelfde pagina voorkomt.
   ========================================================================== */

document.addEventListener('DOMContentLoaded', function () {
    /* ------------------------------------------------------------------
     BUNDEL-KOP: zet "Kies je bundel" / "Choose your bundle"
     boven de Kaching-bundels (taal gaat automatisch)
     ------------------------------------------------------------------ */
  (function boelouBundelKop() {
    var engels = (document.documentElement.lang || '').toLowerCase().indexOf('en') === 0;
    var tekst = engels ? 'Choose your bundle' : 'Kies je bundel';

    function plaats() {
      document.querySelectorAll('kaching-bundle').forEach(function (bundel) {
        if (bundel.getAttribute('data-boelou-kop')) return; // nooit dubbel
        bundel.setAttribute('data-boelou-kop', '1');

        var kop = document.createElement('p');
        kop.className = 'boelou-bundle-title';
        kop.textContent = tekst;
        bundel.insertAdjacentElement('beforebegin', kop);
      });
    }

    plaats();
    var observer = new MutationObserver(plaats);
    observer.observe(document.body, { childList: true, subtree: true });
    setTimeout(function () { observer.disconnect(); }, 15000);
  })();

    /* ------------------------------------------------------------------
     DIFFUSER-CALCULATOR: (huis/appartement) → ruimtes → advies (max 3) →
     bijpassende Kaching-bundel wordt meteen automatisch geselecteerd.
     Huis: woonkamer telt als 2, andere ruimtes als 1.
     Appartement: elke ruimte telt als 1.
     Werkt in de NL- en EN-winkel (teksten via data-attributen in de HTML).
     ------------------------------------------------------------------ */
  (function boelouCalcStart() {
    var MAX = 3;
    var STANDAARD_BUNDELS = ['', '1 Diffuser + 2 Navullingen', '2 Diffusers + 4 Navullingen', '3 Diffusers + 6 Navullingen'];
    var BADGE_TEKSTEN = ['bijna uitverkocht', 'almost sold out'];

    function normaal(t) {
      return (t || '').replace(/\s+/g, ' ').trim().toLowerCase();
    }

    function zichtbaar(el) {
      return !!(el && el.offsetParent !== null && el.offsetHeight > 0);
    }

    // Klimt omhoog zolang de ouder alleen dit element bevat (zodat we het hele blok pakken)
    function heelBlok(el) {
      while (el.parentElement &&
             el.parentElement !== document.body &&
             el.parentElement.tagName !== 'FORM' &&
             el.parentElement.children.length === 1) {
        el = el.parentElement;
      }
      return el;
    }

    // Zoekt de badge "Bijna uitverkocht" / "Almost sold out"
    function vindBadge(section) {
      var b = document.querySelector('.boelou-stock-badge');
      if (b && zichtbaar(b)) return b;

      var kandidaten = document.querySelectorAll('div, p, span');
      for (var i = 0; i < kandidaten.length; i++) {
        var el = kandidaten[i];
        if (section.contains(el) || el.children.length > 3) continue;
        var t = normaal(el.textContent);
        if (!t || t.length > 40) continue;
        for (var j = 0; j < BADGE_TEKSTEN.length; j++) {
          if (t.indexOf(BADGE_TEKSTEN[j]) === 0 && zichtbaar(el)) return heelBlok(el);
        }
      }
      return null;
    }

    // Zoekt de zichtbare winkelwagenknop
    function vindKnop(section) {
      var knoppen = document.querySelectorAll(
        'form[action*="/cart/add"] button[name="add"], form[action*="/cart/add"] [type="submit"]'
      );
      for (var i = 0; i < knoppen.length; i++) {
        if (section.contains(knoppen[i])) continue;
        if (zichtbaar(knoppen[i])) return heelBlok(knoppen[i]);
      }
      return null;
    }

    // Plaatst de calculator direct onder de badge, of anders direct boven de winkelwagenknop
    function verplaats(section) {
      function probeer() {
        var badge = vindBadge(section);
        if (badge) {
          if (badge.nextElementSibling !== section) {
            badge.insertAdjacentElement('afterend', section);
          }
          section.classList.add('calc-in-form');
          return true;
        }

        var knop = vindKnop(section);
        if (knop) {
          if (knop.previousElementSibling !== section) {
            knop.parentNode.insertBefore(section, knop);
          }
          section.classList.add('calc-in-form');
        }
        return false;
      }

      if (probeer()) return;

      var bezig = false;
      var observer = new MutationObserver(function () {
        if (bezig) return;
        bezig = true;
        requestAnimationFrame(function () {
          bezig = false;
          if (probeer()) observer.disconnect();
        });
      });
      observer.observe(document.body, { childList: true, subtree: true });

      setTimeout(function () { observer.disconnect(); }, 15000);
    }

    // Alle plekken waar Kaching zijn bundels tekent (ook binnen een afgeschermde shadow root)
    function kachingRoots() {
      var roots = [];
      document.querySelectorAll('kaching-bundle, kaching-bundles-block').forEach(function (el) {
        roots.push(el);
        if (el.shadowRoot) roots.push(el.shadowRoot);
      });
      return roots;
    }

    // Methode 1: zoek het element met de bundeltekst en geef het diepste element terug
    function vindOpTekst(naam) {
      if (!naam) return null;
      var zoek = normaal(naam);
      var roots = kachingRoots();
      for (var r = 0; r < roots.length; r++) {
        var alle = roots[r].querySelectorAll('*');
        for (var i = 0; i < alle.length; i++) {
          var el = alle[i];
          if (normaal(el.textContent).indexOf(zoek) === -1) continue;
          var dieper = Array.prototype.some.call(el.children, function (k) {
            return normaal(k.textContent).indexOf(zoek) !== -1;
          });
          if (!dieper) return el;
        }
      }
      return null;
    }

    // Methode 2 (reserve): n-de optie op volgorde
    function vindOpVolgorde(n) {
      var roots = kachingRoots();
      var selectors = ['input[type="radio"]', '.kaching-bundles__bar'];
      for (var s = 0; s < selectors.length; s++) {
        for (var r = 0; r < roots.length; r++) {
          var els = roots[r].querySelectorAll(selectors[s]);
          if (els.length >= n) return els[n - 1];
        }
      }
      return null;
    }

    // Selecteert bundel n (zonder te scrollen)
    function selecteerBundel(n, namen) {
      var el = vindOpTekst(namen[n]) || vindOpVolgorde(n);
      if (!el) {
        console.warn('[Boelou calculator] Bundel niet gevonden:', n);
        return;
      }

      var radio = null;
      var p = el;
      for (var stap = 0; stap < 8 && p && !radio; stap++) {
        if (p.querySelector) radio = p.querySelector('input[type="radio"]');
        p = p.parentElement;
      }

      if (radio && el.tagName !== 'INPUT') {
        if (!radio.checked) radio.click();
      } else {
        el.click();
      }
    }

    function init() {
      document.querySelectorAll('.boelou-calc').forEach(function (section) {
        if (section.getAttribute('data-calc-ready')) return; // nooit dubbel koppelen
        section.setAttribute('data-calc-ready', '1');

        verplaats(section);

        // Teksten per winkel (uit de HTML), met Nederlandse standaard
        var labelAdvies   = section.getAttribute('data-label-advies')    || 'Ons advies';
        var labelLeeg     = section.getAttribute('data-label-leeg')      || 'Kies eerst een ruimte';
        var labelType     = section.getAttribute('data-label-type')      || 'Kies eerst je woning';
        var labelAllHouse = section.getAttribute('data-label-all-house') || 'Gehele Huis';
        var labelAllApt   = section.getAttribute('data-label-all-apt')   || 'Geheel appartement';
        var bundelAttr    = section.getAttribute('data-bundles');
        var namen = bundelAttr ? [''].concat(bundelAttr.split('|')) : STANDAARD_BUNDELS;

        // Oude onderdelen opruimen als ze nog in de HTML staan
        section.querySelectorAll('.calc-btn, .calc-note, .calc-rule').forEach(function (el) {
          el.parentNode.removeChild(el);
        });

        var types     = section.querySelectorAll('.calc-type');
        var roomsWrap = section.querySelector('.calc-rooms');
        var rooms     = section.querySelectorAll('.calc-tile.room');
        var all       = section.querySelector('.calc-all');
        var allTxt    = section.querySelector('.calc-all-txt');
        var diffs     = section.querySelector('.calc-diffs');
        var big       = section.querySelector('.calc-big');
        var img       = section.getAttribute('data-diffuser-img');
        if (!rooms.length || !diffs || !big) return;

        // De woonkamer: kaartje met data-room="living", anders het eerste kaartje
        var woonkamer = section.querySelector('.calc-tile.room[data-room="living"]') || rooms[0];

        // Geen huis/appartement-stap in de HTML? Dan werkt hij zoals voorheen (1 per ruimte)
        var type = types.length ? null : 'apt';
        if (!types.length && roomsWrap) roomsWrap.classList.remove('is-locked');

        // Balk "Kies eerst..." aanmaken als die nog niet in de HTML staat
        var leeg = section.querySelector('.calc-empty');
        if (!leeg) {
          leeg = document.createElement('div');
          leeg.className = 'calc-empty';
          diffs.parentNode.insertBefore(leeg, diffs);
        }

        // Advies-kaartje om de diffusers + advies heen zetten als dat nog niet zo is
        var advies = section.querySelector('.calc-advies');
        if (!advies) {
          advies = document.createElement('div');
          advies.className = 'calc-advies';
          diffs.parentNode.insertBefore(advies, diffs);
          advies.appendChild(diffs);
          advies.appendChild(big);
        }

        var laatstGeselecteerd = 0;

        function zet(tile, aan) {
          tile.classList.toggle('on', aan);
          tile.setAttribute('aria-pressed', aan ? 'true' : 'false');
        }

        function update() {
          var gekozen = section.querySelectorAll('.calc-tile.room.on').length;

          // Huis: de woonkamer telt dubbel. Andere ruimtes en appartement: 1 per ruimte.
          var extra = (type === 'house' && woonkamer && woonkamer.classList.contains('on')) ? 1 : 0;
          var aantal = gekozen ? Math.min(gekozen + extra, MAX) : 0;
          if (all) zet(all, gekozen === rooms.length);

          section.classList.toggle('has-advies', aantal > 0);
          leeg.textContent = type ? labelLeeg : labelType;
          leeg.hidden = aantal > 0;
          advies.hidden = !aantal;

          diffs.innerHTML = '';
          for (var i = 0; i < aantal; i++) {
            var el = document.createElement('img');
            el.src = img;
            el.alt = '';
            diffs.appendChild(el);
          }
          diffs.hidden = !aantal;

          big.hidden = !aantal;
          big.textContent = aantal ? labelAdvies + ': ' + aantal + ' diffuser' + (aantal > 1 ? 's' : '') : '';

          // Bundel bovenaan meteen meeschakelen
          if (aantal && aantal !== laatstGeselecteerd) {
            selecteerBundel(aantal, namen);
            laatstGeselecteerd = aantal;
          }
        }

        // Stap 1: huis of appartement
        types.forEach(function (btn) {
          btn.addEventListener('click', function () {
            type = btn.getAttribute('data-type');
            types.forEach(function (b) { zet(b, b === btn); });
            if (roomsWrap) roomsWrap.classList.remove('is-locked');
            if (allTxt) allTxt.textContent = type === 'house' ? labelAllHouse : labelAllApt;
            update();
          });
        });

        // Stap 2: ruimtes
        rooms.forEach(function (tile) {
          tile.addEventListener('click', function () {
            if (!type) return;
            zet(tile, !tile.classList.contains('on'));
            update();
          });
        });

        if (all) {
          all.addEventListener('click', function () {
            if (!type) return;
            var aan = !all.classList.contains('on');
            rooms.forEach(function (r) { zet(r, aan); });
            update();
          });
        }

        update();
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();
  
  /* ------------------------------------------------------------------
   PRODUCTEN: swipe-dots die meebewegen met de horizontale scroll
   ------------------------------------------------------------------ */
(function boelouProductsSwipeDots() {
  var sections = document.querySelectorAll('.boelou-products');

  sections.forEach(function (section) {
    var track = section.querySelector('.prods');
    var cards = section.querySelectorAll('.pcard');
    var dots  = section.querySelectorAll('.swipe-dots span');
    if (!track || !dots.length) return;

    function currentIndex() {
      var scrollLeft = track.scrollLeft;
      var best = 0, bestDist = Infinity;
      cards.forEach(function (card, i) {
        var dist = Math.abs(card.offsetLeft - track.offsetLeft - scrollLeft);
        if (dist < bestDist) { bestDist = dist; best = i; }
      });
      return best;
    }

    var scrollTimeout;
    track.addEventListener('scroll', function () {
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(function () {
        var idx = currentIndex();
        dots.forEach(function (dot, i) {
          dot.classList.toggle('active', i === idx);
        });
      }, 80);
    });
  });
})();

  /* ------------------------------------------------------------------
     REVIEWS: swipe-dots die meebewegen met de horizontale scroll
     ------------------------------------------------------------------ */
  (function boelouReviewsSwipeDots() {
    var sections = document.querySelectorAll('.boelou-reviews');

    sections.forEach(function (section) {
      var track = section.querySelector('.rev-grid');
      var cards = section.querySelectorAll('.rev');
      var dots = section.querySelectorAll('.swipe-dots span');
      if (!track || !dots.length) return;

      function currentIndex() {
        var scrollLeft = track.scrollLeft;
        var best = 0, bestDist = Infinity;
        cards.forEach(function (card, i) {
          var dist = Math.abs(card.offsetLeft - track.offsetLeft - scrollLeft);
          if (dist < bestDist) { bestDist = dist; best = i; }
        });
        return best;
      }

      var scrollTimeout;
      track.addEventListener('scroll', function () {
        clearTimeout(scrollTimeout);
        scrollTimeout = setTimeout(function () {
          var idx = currentIndex();
          dots.forEach(function (dot, i) {
            dot.classList.toggle('active', i === idx);
          });
        }, 80);
      });
    });
  })();

  /* ------------------------------------------------------------------
     DOGCAT: mobiele hond/kat-tabs
     ------------------------------------------------------------------ */
  (function boelouDogcatTabs() {
    var sections = document.querySelectorAll('.boelou-dogcat');

    sections.forEach(function (section) {
      var tabs = section.querySelectorAll('.tab');
      var panels = section.querySelectorAll('.col');

      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          var target = tab.getAttribute('data-target');

          tabs.forEach(function (t) { t.classList.remove('active'); });
          tab.classList.add('active');

          panels.forEach(function (panel) {
            if (panel.getAttribute('data-panel') === target) {
              panel.classList.add('panel-active');
            } else {
              panel.classList.remove('panel-active');
            }
          });
        });
      });
    });
  })();

});

(function () {
  const PHOTOS = [
    'https://cdn.shopify.com/s/files/1/1071/1436/5258/files/review-avatar-1.jpg',
    'https://cdn.shopify.com/s/files/1/1071/1436/5258/files/review-avatar-2.jpg',
    'https://cdn.shopify.com/s/files/1/1071/1436/5258/files/review-avatar-3.jpg',
    'https://cdn.shopify.com/s/files/1/1071/1436/5258/files/review-avatar-4.jpg',
    'https://cdn.shopify.com/s/files/1/1071/1436/5258/files/review-avatar-5.jpg',
    'https://cdn.shopify.com/s/files/1/1071/1436/5258/files/review-avatar-6.jpg',
  ];

  const INTERVAL_MS = 4000;
  const EASE = '0.6s cubic-bezier(0.65, 0, 0.35, 1)';

  const L = 44;
  const M = 36;
  const OV = 10;

  const S0_LEFT = 0;
  const S1_LEFT = L - OV;
  const S2_LEFT = S1_LEFT + (M - OV);

  const SLOTS = [
    { left: S0_LEFT, top: 0, size: L, z: 3 },
    { left: S1_LEFT, top: (L - M) / 2, size: M, z: 2 },
    { left: S2_LEFT, top: (L - M) / 2, size: M, z: 1 },
  ];

  const ENTRY = { left: -(L + 10), top: 0, size: L, z: 4 };
  const EXIT = { left: S2_LEFT + M + 10, top: (L - M) / 2, size: M, z: 0 };

  const stack = document.getElementById('brbAvatarStack');
  if (!stack) return;

  let nextPhotoIndex = 0;
  let animating = false;
  const avatars = [];

  function nextPhoto() {
    const url = PHOTOS[nextPhotoIndex % PHOTOS.length];
    nextPhotoIndex++;
    return url;
  }

  function applyPos(el, pos, animate) {
    el.style.transition = animate
      ? `left ${EASE}, top ${EASE}, width ${EASE}, height ${EASE}, opacity ${EASE}`
      : 'none';
    el.style.left = pos.left + 'px';
    el.style.top = pos.top + 'px';
    el.style.width = pos.size + 'px';
    el.style.height = pos.size + 'px';
    el.style.zIndex = pos.z;
    el.style.opacity = '1';
  }

  function makeAvatar(url, pos) {
    const el = document.createElement('div');
    el.className = 'avatar';
    el.style.backgroundImage = `url('${url}')`;
    applyPos(el, pos, false);
    stack.appendChild(el);
    return el;
  }

  for (let i = 0; i < 3; i++) {
    avatars.push(makeAvatar(nextPhoto(), SLOTS[i]));
  }

  stack.style.width = (S2_LEFT + M) + 'px';
  stack.style.height = L + 'px';

  function advance() {
    if (animating) return;
    animating = true;

    const incoming = makeAvatar(nextPhoto(), ENTRY);
    incoming.getBoundingClientRect();

    requestAnimationFrame(() => {
      avatars[2].style.transition =
        `left ${EASE}, top ${EASE}, width ${EASE}, height ${EASE}, opacity ${EASE}`;
      avatars[2].style.left = EXIT.left + 'px';
      avatars[2].style.top = EXIT.top + 'px';
      avatars[2].style.width = EXIT.size + 'px';
      avatars[2].style.height = EXIT.size + 'px';
      avatars[2].style.zIndex = EXIT.z;
      avatars[2].style.opacity = '0';

      applyPos(avatars[1], SLOTS[2], true);
      applyPos(avatars[0], SLOTS[1], true);
      applyPos(incoming, SLOTS[0], true);

      const exiting = avatars[2];
      exiting.addEventListener('transitionend', () => {
        exiting.remove();
        animating = false;
      }, { once: true });

      avatars[2] = avatars[1];
      avatars[1] = avatars[0];
      avatars[0] = incoming;
    });
  }

  setInterval(advance, INTERVAL_MS);
})();

(function () {
  const slides = document.getElementById('nsSlides');
  const dots = document.getElementById('nsDots');
  if (!slides || !dots) return;

  const dotEls = dots.children;

  slides.addEventListener('scroll', () => {
    const slideWidth = slides.children[0].getBoundingClientRect().width + 10;
    const index = Math.round(slides.scrollLeft / slideWidth);
    for (let i = 0; i < dotEls.length; i++) {
      dotEls[i].classList.toggle('active', i === index);
    }
  });
})();

/* ------------------------------------------------------------------
    CART: Mystery Gift not clickable in cart drawer
    ------------------------------------------------------------------ */

document.addEventListener('click', function (event) {
  var link = event.target.closest('.horizontal-product[data-handle="mystery-gift"] a');
  if (link) {
    event.preventDefault();
    event.stopPropagation();
  }
}, true);

// ============================================
// SECTION STORE FORM GOES IN KLAVIYO FLOW
// ============================================
(function() {
  var processedForms = new WeakSet();
  
  document.addEventListener('submit', function(e) {
    var form = e.target;
    
    var isPopupForm = form.className && form.className.indexOf('modal-popup') !== -1;
    if (!isPopupForm) return;
    
    // Voorkom oneindige lus
    if (processedForms.has(form)) return;

    var emailInput = form.querySelector('input[type="email"], input[name="contact[email]"]');
    if (!emailInput || !emailInput.value) return;

    // Stop deze submit, doe Klaviyo call, en submit dan opnieuw
    e.preventDefault();
    e.stopPropagation();
    
    var email = emailInput.value;
    processedForms.add(form);

    fetch('https://a.klaviyo.com/client/subscriptions/?company_id=VSF5Yj', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'revision': '2024-10-15'
      },
      body: JSON.stringify({
        data: {
          type: 'subscription',
          attributes: {
            custom_source: 'Section Store Popup',
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email: email
                }
              }
            }
          },
          relationships: {
            list: { 
              data: { 
                type: 'list', 
                id: 'YjuTuB' 
              } 
            }
          }
        }
      })
    }).then(function() {
      // Klaaviyo is klaar — laat Section Store nu zijn eigen flow doen
      form.submit();
    }).catch(function(err) { 
      console.error('Klaviyo error:', err);
      // Ook bij fout: laat Section Store zijn ding doen zodat de gebruiker niet vastloopt
      form.submit();
    });
  }, true);
})();